// PreventiApp — Landing · CTA "Solicitar Demo"
// Coordina el click del CTA: dispara tracking, pre-selecciona el motivo del
// formulario de contacto y hace scroll suave a la sección #contacto.
//
// Uso:
//   import { openDemoRequest } from '../../lib/demoRequest';
//   <button onClick={() => openDemoRequest('header')}>Solicitar Demo</button>
//
// Contacto.jsx escucha el CustomEvent `preventi:demo-request` para setear
// motivo='demo' y resaltar la opción "Solicitud de Demo" en el formulario.

import { trackEvent } from './tracking';

/**
 * @param {'header'|'hero'|string} location  Origen del click (para tracking).
 */
export function openDemoRequest(location = 'unknown') {
  // 1) Tracking dedicado — permite medir embudo Demo → envío
  trackEvent('demo_request_click', { location });

  // 2) Notificar al formulario para pre-seleccionar el motivo
  try {
    window.dispatchEvent(
      new CustomEvent('preventi:demo-request', { detail: { location } }),
    );
  } catch (_) { /* no-op */ }

  // 3) Scroll suave al bloque de contacto
  const el = document.getElementById('contacto');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
